<template>
  <div class="hello">

      <!-- Fake method to load original values -->
      {{loadOriginalValues}}

    <transition name="fade">
        <div v-if="checkingAddress" class="loading">
            <p>Checking Your Address</p>
        </div>
    </transition>

        <!-- Incorrect address modal -->
        <b-modal no-fade size="l" id="modal-invalidaddress" title="This Does Not Seem To Be a Valid Address" 
            cancel-title="Use this address anyway" ok-only ok-title="Let me try again" @cancel="useInvalidAddress()">
                Please check the address and try again
        </b-modal>

        <!-- Modal to display corrected address -->
        <b-row>
            <b-col>
                <b-modal no-fade size="l" id="modal-newaddress" title="We Found a Matching Address" 
                ok-title="Yes, Update"  @ok="submitAddress()">
                        <template v-slot:default="{ hide }">
                            <p>{{validatedAddress.street1}}</p>
                            <p>{{validatedAddress.street2}}</p>
                            <p>{{validatedAddress.city}}, {{validatedAddress.state}} {{validatedAddress.zip}}</p>
                        </template>
                </b-modal>
            </b-col>
        </b-row>

    <b-container>
        <b-row>
            <b-col style="color:red"> * = required</b-col>
        </b-row>

        <b-row>
            <b-col>
                <!-- Use lazy so message shows once user has stopped typing -->
                <b-input-group prepend="Company *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.company.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.company.minLength">Must have at least {{ $v.contactForm.company.$params.minLength.min }} characters.</p>
                <p class="error" v-if="!$v.contactForm.company.required">this field is required</p>

                <b-input-group prepend="Contact Name *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.contactname.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.contactname.minLength">Must have at least {{ $v.contactForm.contactname.$params.minLength.min }} characters.</p>


                <b-input-group prepend="Phone *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.phone.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.phone.phonevalidator">Invalid phone number.</p>


                <b-input-group prepend="Street1 *" class="mt-3">
                    <b-form-input v-model="contactForm.street1" @input="checkForm"></b-form-input>
                </b-input-group>

                <!--
                <b-input-group prepend="Street1 *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.street1.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.street1.minLength">Must have at least {{ $v.contactForm.street1.$params.minLength.min }} characters.</p>
                -->
                
                <b-input-group prepend="Street2" class="mt-3">
                    <b-form-input v-model="$v.contactForm.street2.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <b-input-group prepend="City *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.city.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.city.minLength">Must have at least {{ $v.contactForm.city.$params.minLength.min }} characters.</p>

                <b-input-group prepend="Zip *" class="mt-3">
                    <b-form-input v-model="$v.contactForm.zip.$model" @input="checkForm"></b-form-input>
                </b-input-group>
                <p class="error" v-if="!$v.contactForm.zip.zipvalidator">Invalid zip.</p>

                <!-- State -->
                <b-row style="margin-bottom:20px; margin-top:10px">
                    <b-col>
                        <div class="mt-3" >Select your state*</div>
                        <b-form-select style="width:200px" v-model="addressState" :options="statesList">
                        </b-form-select>
                        <br>
                    </b-col>
                </b-row>
                
            </b-col>
        </b-row>

        <!-- Control buttons -->
        <b-row style="margin-bottom:50px">
            <b-col>
                <b-button @click="previous">Previous</b-button>
                <b-button @click="next" :disabled="!formValid">Next</b-button>
            </b-col>
        </b-row>


    </b-container>
      
  </div>
</template>

<script>

import { mapState } from 'vuex'
import { required, minLength, between } from 'vuelidate/lib/validators'
import { helpers } from 'vuelidate/lib/validators'
import { usStates } from '../Myfunctions'
import { checkAddress } from '../Myfunctions'

const phonevalidator = helpers.regex('phonevalidator', /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/)

const zipvalidator = helpers.regex('zipvalidator', /^[0-9]{5}(?:-[0-9]{4})?$/)

export default {    
    props: {
    },

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser', 'newUserAddress', 'newUserContactName', 'newUserContactPhone', 'newUserCompany']),

        //Fake to load stored info
        loadOriginalValues(){
            //Load original values only if new value is blank
            if(this.newUserCompany&&!this.contactForm.company) this.contactForm.company=JSON.parse(JSON.stringify(this.newUserCompany))
            if(this.newUserContactName&&!this.contactForm.contactname) this.contactForm.contactname=JSON.parse(JSON.stringify(this.newUserContactName))
            if(this.newUserContactPhone&&!this.contactForm.phone) this.contactForm.phone=JSON.parse(JSON.stringify(this.newUserContactPhone))
            if(!(this.newUserAddress=== 'undefined')){

                if(this.newUserAddress.street1&&!this.contactForm.street1) this.contactForm.street1=JSON.parse(JSON.stringify(this.newUserAddress.street1))
                if(this.newUserAddress.street2&&!this.contactForm.street2) this.contactForm.street2=JSON.parse(JSON.stringify(this.newUserAddress.street2))
                if(this.newUserAddress.city&&!this.contactForm.city) this.contactForm.city=JSON.parse(JSON.stringify(this.newUserAddress.city))
                if(this.newUserAddress.state&&!this.addressState) this.addressState=JSON.parse(JSON.stringify(this.newUserAddress.state))
                if(this.newUserAddress.zip&&!this.contactForm.zip) this.contactForm.zip=JSON.parse(JSON.stringify(this.newUserAddress.zip))
                if(this.newUserAddress.county&&!this.contactForm.county) this.contactForm.county=JSON.parse(JSON.stringify(this.newUserAddress.county))
            }
            //Check form
            this.checkForm()
            
        }

    },

    components: {
    },

    data() {
        return {
            contactForm:{
                company:"",
                contactname:"",
                phone:"",
                street1:"",
                street2:"",
                city:"",
                state:"",
                zip:"",
                county:"",
                
            },
            formValid:false,
            county:"",
            statesList:[],
            addressState:"",
            checkingAddress:false,
            validatedAddress:{},
            
        }
    },
    validations: {
        contactForm:{
            company: {
                    required,
                    minLength: minLength(4)
                },
                contactname: {
                    required,
                    minLength: minLength(4)
                },
                phone: {
                    required,
                    phonevalidator,
                },
                street1: {
                    required,
                    minLength: minLength(4)
                },
                street2: {

                },
                city: {
                    required,
                    minLength: minLength(2)
                },
                zip: {
                    required,
                    zipvalidator,

                },
            },  
            addressState: {
                    required,
                    minLength: minLength(4)
                },

        },
                 
    methods:{
        checkForm(){
            //console.log("Checking street: "+this.contactForm.street1)
            if((!this.$v.contactForm.$invalid)&&this.addressState) this.formValid=true
            else this.formValid=false
        },

        next(){
            this.$nextTick(() => {
                        this.saveInfoToStore()
                    })
            this.$nextTick(() => {
                    this.checkAddress()
                })
            
            //Check address
            
            //this.$emit('next', {value: true});

        },
        previous(){
            this.saveInfoToStore()
            this.$emit('previous', {value: true});

        },

        saveInfoToStore(){
            console.log("Saving street: "+this.contactForm.street1)
            var address={
                street1:this.contactForm.street1,
                street2:this. contactForm.street2,
                city:this.contactForm.city,
                zip:this.contactForm.zip,
                county:"US",
                county:this.county,
                state:this.addressState,
            }
            this.$store.commit('setNewUserAddress', address)
            this.$store.commit('setNewUserContactName', this.contactForm.contactname)
            this.$store.commit('setNewUserContactPhone', this.contactForm.phone)
            this.$store.commit('setNewUserCompany', this.contactForm.company)

        },

        //Check address
        checkAddress(){
            if(!this.contactForm.street2) this.contactForm.street2 =''
            this.checkingAddress = true

            //Function to capitalize first letter of each word
            function titleCase(str) {
                var splitStr = str.toLowerCase().split(' ');
                for (var i = 0; i < splitStr.length; i++) {
                    // You do not need to check if i is larger than splitStr length, as your for does that for you
                    // Assign it back to the array
                    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1).toLowerCase();     
                }
                // Directly return the joined string
                return splitStr.join(' '); 
            }

            //Promise for address check
            var correctedAddress = checkAddress(this.contactForm.street1, this.contactForm.street2, this.contactForm.city, this.contactForm.zip, this.addressState).then(response => {
                console.log("In response")
                this.checkingAddress = false

                //Invalid address
                if (response=='ERROR'){
                    console.log("ERROR")
                    this.$bvModal.show("modal-invalidaddress")
                } 
                else {
                    console.log(response.data)
                    var newAddress = response.data
                    if(newAddress.status=="INVALID"){
                        this.$bvModal.show("modal-invalidaddress")
                        return
                    }
                        

                    //New address found
                    else if (newAddress.status=="SUSPECT"){
                        //If no county, check address
                        if(!newAddress.county){
                            this.$bvModal.show("modal-invalidaddress")
                            return
                        }

                        
                        newAddress.county = titleCase(newAddress.county)
                        this.validatedAddress.county=newAddress.county
                        this.validatedAddress.street1 = newAddress.addressline1
                        this.validatedAddress.county = titleCase(newAddress.county)
                        if(this.validatedAddress.street2)
                            this.validatedAddress.street2 = newAddress.addressline2
                        else
                            this.validatedAddress.street2 = ""
                        
                        this.addressState=newAddress.state
                        this.validatedAddress.state=newAddress.state
                        this.validatedAddress.city=newAddress.city
                        this.validatedAddress.zip = newAddress.postalcode.substr(0, 5);
                        console.log("Updating address = ")
                        console.log(this.validatedAddress)
                        this.$bvModal.show("modal-newaddress")

                    }

                    //User entered a good address
                    else{
                        this.validatedAddress.street1 = newAddress.addressline1
                        if(this.validatedAddress.street2)
                            this.validatedAddress.street2 = newAddress.addressline2
                        else
                            this.validatedAddress.street2 = ""
                        this.validatedAddress.zip = newAddress.postalcode.substr(0, 5)
                        this.validatedAddress.county = titleCase(newAddress.county)
                        this.validatedAddress.state=newAddress.state
                        this.validatedAddress.city=newAddress.city
                        console.log("Old state: " + this.addressState + ' New state: '+newAddress.state)
                        this.addressState=newAddress.state
                        this.submitAddress()

                    }
                }
            })

        },

            submitAddress(){
                console.log("Address good, submitting")
                console.log(this.validatedAddress)
                this.$store.commit('setNewUserAddress', this.validatedAddress)

                //Store address

                //Save address to state
                this.$emit('next', {value: true});
            },

            useInvalidAddress(){

            },
    },

    mounted(){
        var arrayLength = usStates.length
        for (var i=0; i<arrayLength; i++) this.statesList.push(usStates[i].abbreviation)
    },
}
</script>

<style scoped>
.error {
  color: red;
  font-size:12px;
}

</style>

